import { render, staticRenderFns } from "./UseCategories.vue?vue&type=template&id=162cc825&scoped=true"
import script from "./UseCategories.js?vue&type=script&lang=js&external"
export * from "./UseCategories.js?vue&type=script&lang=js&external"
import style0 from "./UseCategories.vue?vue&type=style&index=0&id=162cc825&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162cc825",
  null
  
)

export default component.exports